Vue.component("comment_item", {
  props: {
      course_id: {
        type: String,
        required: true,
        default: ""
      },
      content: {
          type: Object,
          required: true,
          default: () => ({})
      },
      isReply: {
          type: Boolean,
          default: false
      },
      user_info: {
          type: Object,
          required: true,
          default: () => ({})
      },
      teachers_code: {
        type: Array,
        required: true,
        default: () => []
      }
  },
  data() {
      return {
          isShowInput: false,
          commentValue: "",
          isAnonymous: false,
      }
  },
  computed: {
      isTeacher() {
          return roles => roles.includes("r_teacher")
      },
      canDelete() {
        return this.user_info.user_code == this.content.user_id || this.user_info.roles?.includes('r_sys_manager') || this.user_info.roles?.includes('r_course_manager') || this.teachers_code.includes(this.user_info.user_code)
      }
  },
  methods: {
      handleShowInput() {
        if (!this.content.can_reply) return;
          this.isShowInput = !this.isShowInput;
          this.commentValue = "";
      },
      handleSubmit() {
        if (this.commentValue == "" || this.commentValue == null) {
          this.$message.warning(this.$t("发表内容不能为空！"))
          return
        }
          const params = {
              link_id: this.course_id,
              comment_id: this.content.comment_id,
              content: this.commentValue,
              user_id: this.user_info.user_code,
              user_name: this.user_info.nick_name,
              user_roles: this.user_info.roles,
              target_reply_id: this.isReply ? this.content.reply_id : null,
              anonymity: this.isAnonymous
          }
          API.reqSensitiveWord(this.commentValue, this.$t('内容'), () => API.addReply(params)).then(res => {
              if (res.error_msg === "Success") {
                  // this.detailData = res.extend_message.results;
                  this.$message.success({message: this.$t("发表成功"), customClass: 'qustion_success'});
                  this.commentValue = "";
                  this.isShowInput = !this.isShowInput;
                  this.anonymity = false;
                  this.$emit("refresh");
              } else {
                  this.$message.success({message: this.$t("发表失败"), customClass: 'qustion_success'});
              }
          })
      },
      handleDelete() {
          let params = {}
          if (!this.isReply) {
              params.comment_id_list = [this.content.comment_id]
          } else {
              params.reply_id_list = [this.content.reply_id]
          }
          API[this.isReply ? "deleteReply" : "deleteComment"]({ ...params, link_id: this.course_id }).then(res => {
              if (res.error_msg === "Success") {
                  this.$message.success(this.$t("删除成功"));
                  this.$emit("delete", this.isReply);
              } else {
                  this.$message.success(jQuery.$t("删除失败"));
              }
          })
      }
  },
  template: `
  <div class="comment-item">
    <div class="comment-header-container">
      <div class="avatar">
        <el-image :src="content.avatar_url">
          <div slot="error" class="image-slot">
              <img src="/learn/static/imgs/default_avatar.png">
          </div>
        </el-image>
      </div>
      <div class="name-container">
        <span :class="{ name: true, isOverflow: isTeacher(content.user_roles) && isReply}" :title="content.user_name">{{content.user_name}}</span>
        <span v-if="isTeacher(content.user_roles)" class="tag">{{$t('老师')}}</span>
      </div>
      <div v-if="content.target_user_id" class="target-name-container">
        <span class="text">{{$t('回复')}}</span>
        <span :class="{'target-name': true, isOverflow: isTeacher(content.target_user_roles) && isReply}" :title="content.target_user_name">{{content.target_user_name}}</span>
        <span v-if="isTeacher(content.target_user_roles)" class="tag">{{$t('老师')}}</span>
      </div>
    </div>
    <div class="comment-content">{{content.content}}</div>
    <div class="comment-btn-container">
      <div class="comment-date"><i class="el-icon-time"></i>{{dateFormate(Number(content.created + '000'), "y.m.d h:i")}}</div>
      <div class="comment-btn">
          <el-tooltip :disabled="content.can_reply" :content="!content.can_reply && content.permissions == '1' ? $t('仅教师团队可继续回复') : !content.can_reply && content.permissions == '2' ? $t('仅提问人和教师团队可继续回复') : null">
            <el-button
              class="comment"
              :class="{ hover: isShowInput }"
              :style="{color: content.can_reply? '#2e2e2e' : '#ccc'}"
              size="mini"
              type="text"
              @click="handleShowInput"
            ><iconfont type="iconkuaisuhuifu"></iconfont>{{$t('回复')}}</el-button>
        </el-tooltip>
        <div class="col-line" v-if="canDelete"></div>
        <el-popconfirm
          :title="$t('确定删除当前回复吗？')"
          @confirm="handleDelete"
        >
          <div
            v-if="canDelete"
            slot="reference"
            class="delete"
          >
            <iconfont type="icondelete1"></iconfont>{{$t('删除')}}
          </div>
        </el-popconfirm>
      </div>
    </div>
    <div class="reply-btn" v-if="isShowInput">
      <el-input v-model="commentValue" />
      <div class="reply-btn-container">
        <el-tooltip :content="$t('匿名仅对课程内同学生效，老师仍可见真实姓名')">
          <el-checkbox v-if="window.location.pathname.includes('spoc') || window.location.pathname.includes('training')" v-model="isAnonymous">{{$t('匿名发表')}}</el-checkbox>
        </el-tooltip>
        <el-button type="primary" size="small" @click="handleSubmit">{{$t('发表')}}</el-button>
      </div>
    </div>
  </div>
`
})